"use client";

import { store } from "@/redux/store";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import { ReactNode } from "react";
import Navbar from "../v3/Navbar";
import Footer from "../v3/Footer";
import { AudioPlayerProvider } from "@/hooks/useAudioPlayer";
import dynamic from "next/dynamic";

const BreathingExercise = dynamic(() => import("../easter-eggs/BreathingExercise"), { ssr: false });
const CalmingMusic = dynamic(() => import("../easter-eggs/CalmingMusic"), { ssr: false });
const EncouragementToast = dynamic(() => import("../easter-eggs/EncouragementToast"), { ssr: false });
const FutureYouEnvelope = dynamic(() => import("../easter-eggs/FutureYouEnvelope"), { ssr: false });
const ReflectionMode = dynamic(() => import("../easter-eggs/ReflectionMode"), { ssr: false });
import SlideUpBanner from "./SlideUpBanner";

interface GlobalProviderProps {
  children: ReactNode;
}

export default function GlobalProvider({ children }: GlobalProviderProps) {
  return (
    <Provider store={store}>
      <AudioPlayerProvider>
        <Toaster position="bottom-right" richColors />
        <Navbar />
        {children}
        <Footer />
        <CalmingMusic />
      </AudioPlayerProvider>
      <SlideUpBanner />
      <EncouragementToast />
      <ReflectionMode />
      <FutureYouEnvelope />
      <BreathingExercise />
    </Provider>
  );
}
